import { Component, OnInit, Inject } from '@angular/core';
import { CustomerDetailDto } from 'src/app/entity/customerDetailDto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddressDto } from 'src/app/entity/addressDto';
import { Router, ActivatedRoute } from '@angular/router';
import { ContactDto } from 'src/app/entity/contactDto';
import { CustomerService } from '../customer.service';
import { LicenceTableDto } from 'src/app/entity/licenceTableDto';
import { MatTableDataSource } from '@angular/material/table';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

@Component({
  selector: 'app-customer-detail-view',
  templateUrl: './customer-detail-view.component.html',
  styleUrls: ['./customer-detail-view.component.scss'],
})
export class CustomerDetailViewComponent implements OnInit {
  entity: CustomerDetailDto;
  isNew: boolean;

  editMode: boolean;
  address: AddressDto;

  displayedColumns: string[] = [
    'name',
    'licenceTo',
    'userCount',
    'manufacturerCount',
    'buttons',
  ];
  licenceTableData: MatTableDataSource<LicenceTableDto>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CustomerDetailDto,
    public router: Router,
    public dialogRef: MatDialogRef<CustomerDetailViewComponent>,
    private customerService: CustomerService
  ) {
    this.entity = data;
    this.licenceTableData = new MatTableDataSource<LicenceTableDto>();
  }

  ngOnInit(): void {
    console.log(
      this.entity.uuid +
        ' --> id: ' +
        this.entity.uuid +
        ' --> name:' +
        this.entity.name
    );
    this.licenceTableData.data = this.entity.licences;
    registerLocaleData(localeDe, 'de');
  }

  showCustomerDetails(id: number) {
    this.dialogRef.close();

    this.router.navigate(['/customer/detail/' + this.entity.id + '/' + id]);
  }

  abort(): void {
    this.dialogRef.close();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.licenceTableData.filter = filterValue.trim().toLowerCase();
  }
}
